import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { Container, Box, Typography, Button } from "@mui/material";
import { auth } from "../firestore-DB-config/firebase-config"; // Import Firebase authentication
import { onAuthStateChanged } from "firebase/auth";
import CircularProgress from "@mui/material/CircularProgress"; // Import Material-UI spinner
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { Link, Navigate } from "react-router-dom";

const PrivateRoute = ({ showPrompt = true }: { showPrompt?: boolean }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [showPromptState, setShowPrompt] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        if (showPrompt) {
          setShowPrompt(true); // Only show the prompt if showPrompt is true
        }
      }
    });

    return () => unsubscribe();
  }, []);

  if (isAuthenticated === null) {
    return (
      <>
        <Header />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <CircularProgress />
        </div>
        <Footer />
      </>
    );
  }

  if (showPromptState) {
    return (
      <>
        <Header />
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "70vh",
            textAlign: "center",
            my: { xs: 3, sm: 4 }, // Adjust vertical margins for small screens
            px: { xs: 2, sm: 3 }, // Add horizontal padding on smaller screens
          }}
        >
          <Box
            sx={{
              maxWidth: { xs: "100%", sm: "500px" }, // Full width on extra small screens, 500px on larger
              width: "100%", // Ensure full width on small screens
              backgroundColor: "#f9f9f9",
              p: { xs: 2, sm: 4 }, // Adjust padding for small screens
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "24px", sm: "30px" }, // Responsive font size
                fontWeight: "bold",
                mb: 2,
                color: "red",
              }}
            >
              Unauthorized Access!
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "15px" }, // Responsive font size for smaller screens
                mb: 3,
                color: "#666",
              }}
            >
              You are not authorized to access this page. Please log in with
              your credentials to continue.
            </Typography>

            <Button
              variant="contained"
              component={Link}
              to="/login"
              sx={{
                bgcolor: "#007bff",
                color: "white",
                borderRadius: "30px",
                fontWeight: "bold",
                textTransform: "none",
                px: { xs: 3, sm: 4 }, // Padding adjustments for button
                py: { xs: 1, sm: 1.5 },
                width: { xs: "100%", sm: "auto" }, // Full-width button on smaller screens
                "&:hover": {
                  bgcolor: "#0056b3",
                },
              }}
            >
              Go to Login
            </Button>
          </Box>
        </Container>
        <Footer />
      </>
    );
  }
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};
export default PrivateRoute;
